import React from 'react'
import { OverSection, TypographyContent } from './styles'
import { Component } from 'src/types'
import { LineHeight15White } from 'src/components/common/Typography/typography'

export function MapColumn({ link, content, linkDirection, ruta }: Component) {
    return (
        <OverSection>
            {linkDirection ? (
                <a href={ruta} target="_blank" rel="noreferrer">
                    <LineHeight15White
                        variant={'h3'}
                        fontSize={'xxsmall'}
                        fontWeight={400}
                    >
                        {content}
                    </LineHeight15White>
                </a>
            ) : (
                <TypographyContent to={`/${link}`}>
                    <LineHeight15White
                        variant={'h3'}
                        fontSize={'xxsmall'}
                        fontWeight={400}
                    >
                        {content}
                    </LineHeight15White>
                </TypographyContent>
            )}
        </OverSection>
    )
}
